module.exports = __webpack_public_path__ + "static/media/notification.35fef3c0.mp3";